<ng-container [formGroup]="group">
  <mat-checkbox
    *ngIf="showCopyBasicDataButton"
    class="easy-checkbox"
    [disabled]="!basicDataAddress"
    (change)="useBasicDataAddress($event)"
  >
    {{ "MERCHANT.SITES.EDIT.USE_BASIC_ADDRESS" | translate }}
  </mat-checkbox>
  <div class="w-100 gap-4 align-items-end">
    <mat-form-field [fxFlex]="50">
      <label for="googlePlacesAutocomplete">{{
        TITLE + "SEARCH_ADDRESS2" | translate
      }}</label>
      <div class="form-field-container">
        <input
          [formControl]="addressSearch"
          class="suffix"
          id="googlePlacesAutocomplete"
          type="text"
          matInput
          (keydown)="onGoogleKeydown($event)"
        />
        <mat-icon matSuffix>search</mat-icon>
      </div>
    </mat-form-field>
  </div>
  <div class="flex-row gap-4">
    <mat-form-field [fxFlex]="50">
      <app-easy-input
        [label]="TITLE + 'ZIP_CODE' | translate"
        type="number"
        [maxDecimals]="0"
        formControlName="zipCode"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field fxFlex>
      <app-easy-input
        [label]="TITLE + 'CITY' | translate"
        formControlName="city"
      ></app-easy-input>
    </mat-form-field>
  </div>

  <div class="flex-row gap-4">
    <mat-form-field [fxFlex]="50">
      <app-easy-input
        [label]="TITLE + 'STREET_NAME' | translate"
        formControlName="streetName"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field [fxFlex]="35">
      <app-easy-input
        [label]="TITLE + 'STREET_TYPE' | translate"
        formControlName="streetType"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field fxFlex>
      <app-easy-input
        [label]="TITLE + 'NUMBER' | translate"
        formControlName="number"
      ></app-easy-input>
    </mat-form-field>
  </div>

  <div class="flex-row gap-4">
    <div [fxFlex]="50" class="gap-4">
      <mat-form-field fxFlex>
        <app-easy-input
          [label]="TITLE + 'BUILDING' | translate"
          formControlName="building"
        ></app-easy-input>
      </mat-form-field>
      <mat-form-field fxFlex>
        <app-easy-input
          [label]="TITLE + 'STAIRS' | translate"
          formControlName="stairs"
        ></app-easy-input>
      </mat-form-field>
    </div>
    <mat-form-field fxFlex>
      <app-easy-input
        [label]="TITLE + 'FLOOR' | translate"
        formControlName="floor"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field fxFlex>
      <app-easy-input
        [label]="TITLE + 'DOOR' | translate"
        formControlName="door"
      ></app-easy-input>
    </mat-form-field>
  </div>
</ng-container>
